import { network } from 'services/network';

import { QueryParams } from 'api/queries/getKeyAchievementstableData.query';

export const ENDPOINT = 'api/bo/getKeyAchievements';

export const getKeyAchievements = ({
    compareVersionId,
    latestVersionId,
    timePeriod,
    filters,
    narrativeRequest,
}: QueryParams) => {
    const params = {
        compareVersionId: compareVersionId,
        latestVersionId: latestVersionId,
        timePeriod: timePeriod,
        filter: {
            filters,
        },
        withDetails: true,
        ...(narrativeRequest && { narrativeRequest }),
    };

    return network.post(ENDPOINT, params).then((response) => {
        return response.data;
    });
};
